import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const Sec = ({ title, children, testid }) => <section className="rounded-xl border bg-white p-4 space-y-3" data-testid={testid}><h3 className="font-bold text-steel">{title}</h3>{children}</section>;

export function MerchantDiagnostics() {
  const [guide, setGuide] = useState(null);
  const [mm, setMm] = useState(null);
  const [res, setRes] = useState(null);
  useEffect(() => { api.get("/admin/merchant/shipping-guide").then((r) => setGuide(r.data)); }, []);
  const upload = async (e) => {
    const file = e.target.files?.[0]; e.target.value = "";
    if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    try { const r = await api.post("/admin/merchant/diagnostics/import", fd); setRes(r.data); toast.success(`${r.data.matched} items updated`); }
    catch (er) { toast.error(er.response?.data?.detail || "Import failed"); }
  };
  return (
    <div className="space-y-4">
      <Sec title="Merchant Center approval status (import)" testid="gmc-diag-import">
        <p className="text-sm text-muted-foreground">In Merchant Center go to Products → All products (or Needs attention) → Download as CSV, then upload it here. ACP records approved / pending / disapproved and Google's issue text per product.</p>
        <label className="inline-flex"><input type="file" accept=".csv,.tsv,.txt" className="hidden" onChange={upload} data-testid="gmc-diag-file" /><span className="px-3 py-2 rounded-md bg-steel text-white text-sm cursor-pointer">Upload Merchant Center export</span></label>
        {res && <p className="text-sm" data-testid="gmc-diag-result">Matched {res.matched} · not found {res.unmatched}</p>}
      </Sec>
      <Sec title="Price & stock mismatches (live site vs last feed)" testid="gmc-diag-mismatch">
        <Button size="sm" variant="outline" onClick={() => api.get("/admin/merchant/mismatches").then((r) => setMm(r.data))} data-testid="gmc-diag-mismatch-run">Check now</Button>
        {mm && <div className="text-sm"><p>{mm.price_mismatch} price · {mm.stock_mismatch} stock differences — they clear on the next sync.</p>
          {mm.rows.slice(0, 50).map((r) => <p key={r.id} className="text-xs">{r.sku}: feed ${r.feed_price} / live ${r.live_price} · {r.feed_availability} → {r.live_availability}</p>)}</div>}
      </Sec>
      {guide && <Sec title="Shipping in Merchant Center" testid="gmc-diag-shipping">
        <p className="text-sm">Mode: <b>{guide.mode === "inline_max" ? "Inline — highest island rate per item" : "Account rates by shipping label"}</b> · {guide.freight_excluded} freight items kept out · {guide.rural_flagged} rural-quote flags</p>
        <p className="text-xs text-muted-foreground">Eligible items by label: {Object.entries(guide.labels).map(([k, v]) => `${k} ${v}`).join(" · ") || "none"}</p>
        <ol className="list-decimal pl-5 text-sm space-y-1">{guide.steps.map((s, i) => <li key={i}>{s}</li>)}</ol>
      </Sec>}
    </div>
  );
}
